import { useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion";

const LOG_LINES = [
  "saket_os v2.4.1 — cold boot ... OK",
  "bios check — amoled panel ... OK",
  "memory test 640K ... OK",
  "mounting /dev/portfolio ... OK",
  "loading font: jetbrains_mono ... OK",
  "loading modules [react, node, router] ... OK",
  "fetching github.com/saketkhundia ... OK",
  "compiling projects [6 found] ... OK",
  "rendering @ 60fps ... OK",
  "applying theme: retro_dev_bw ... OK",
  "hiding scrollbars ... OK",
  "starting session for guest ...",
];

export default function BootSequence({ onDone }) {
  const [pct, setPct] = useState(0);

  const finish = useCallback(() => {
    onDone();
  }, [onDone]);

  useEffect(() => {
    const duration = 2800;
    const start = performance.now();
    let raf;

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(100, (elapsed / duration) * 100);
      setPct(progress);
      if (progress < 100) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(finish, 200);
      }
    };

    raf = requestAnimationFrame(tick);

    const handleSkip = () => {
      cancelAnimationFrame(raf);
      setPct(100);
      finish();
    };

    const onKey = (e) => {
      if (e.code === "Space" || e.code === "Escape") {
        e.preventDefault();
        handleSkip();
      }
    };

    window.addEventListener("keydown", onKey);
    window.addEventListener("pointerdown", handleSkip, { once: true });

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("pointerdown", handleSkip);
    };
  }, [finish]);

  const visibleLines = Math.min(
    LOG_LINES.length,
    Math.floor((pct / 100) * (LOG_LINES.length + 1))
  );

  return (
    <motion.div
      className="boot-overlay"
      exit={{ scaleY: 0 }}
      transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
    >
      <div className="boot-term">
        <div className="boot-term-bar">
          <span className="boot-term-dots" aria-hidden="true">
            <i /><i /><i />
          </span>
          <span>saket@dev: ~/portfolio — boot.sh</span>
        </div>
        <div className="boot-term-body">
          <div className="boot-log">
            {LOG_LINES.slice(0, visibleLines).map((line, i) => (
              <div key={i} className={line.includes("OK") ? "ok" : ""}>
                {line}
              </div>
            ))}
          </div>
          <p className="boot-percent">{Math.floor(pct)}%</p>
          <div className="boot-bar-wrap">
            <div className="boot-bar-fill" style={{ width: `${pct}%` }} />
          </div>
          <p className="boot-skip">[ press space / esc — tap to skip ]_</p>
        </div>
      </div>
    </motion.div>
  );
}
